import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { mockData } from '../mock';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { SEO } from '../components/SEO';

export const Services = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Driving Lessons & Services in Liverpool"
        description="Comprehensive driving programs in Liverpool: Teen Driver Education, Adult Driving Lessons, Road Test Preparation, and Defensive Driving courses. Flexible scheduling and certified instructors across Merseyside."
        keywords="teen driving lessons Liverpool, adult driving lessons Liverpool, road test prep Liverpool, defensive driving Liverpool, intensive driving course Liverpool, Merseyside driving lessons"
        canonical="https://topdriver.co.uk/services"
      />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl sm:text-6xl font-bold text-black mb-6">
              Our Services
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Comprehensive driving programs tailored to your needs
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {mockData.services.map((service) => (
              <Card
                key={service.title}
                className="border-2 border-gray-200 hover:border-red-600 hover:shadow-xl transition-all duration-300"
              >
                <CardContent className="p-8">
                  <h3 className="text-3xl font-bold text-black mb-4">{service.title}</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">{service.description}</p>
                  <ul className="space-y-3">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-start space-x-3">
                        <CheckCircle2 className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-black mb-4">
            Not Sure Which Service is Right for You?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Contact us today and we'll help you choose the perfect program.
          </p>
          <Button
            asChild
            size="lg"
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg transition-colors duration-200"
          >
            <Link to="/contact">Get in Touch</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Services;